import { css } from '@emotion/react';

const widthLimiter = css`
  margin: auto;
  max-width: 768px;
  width: 100%;
`;

export default { widthLimiter };
